
import etiquetasService from "@/modules/Etiquetas/services/etiquetasService";

export default {
  name: "ProductExamplePicker",
  props: {
    modelUuid: {
      type: String,
      required: true,
    },
    companyId: {
      type: [Number, String],
      default: null,
    },
    selectedProduct: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      search: "",
      results: [],
      loading: false,
      selectingId: null,
      error: "",
      timer: null,
      requestId: 0,
    };
  },
  watch: {
    companyId() {
      this.resetSearch();
    },
  },
  beforeDestroy() {
    if (this.timer) clearTimeout(this.timer);
    this.requestId += 1;
  },
  methods: {
    scheduleSearch() {
      if (this.timer) clearTimeout(this.timer);
      this.requestId += 1;
      this.error = "";
      this.timer = setTimeout(() => {
        this.timer = null;
        this.searchProducts();
      }, 300);
    },
    async searchProducts() {
      const term = this.search.trim();
      const companyId = Number(this.companyId);
      const requestId = this.requestId;
      if (!term || !this.companyId) {
        this.results = [];
        this.loading = false;
        return;
      }

      this.loading = true;
      this.error = "";
      try {
        const { data } = await etiquetasService.buscarProdutosExemplo({
          modelo_uuid: this.modelUuid,
          id_empresa_exemplo: companyId,
          busca: term,
        });
        if (
          requestId !== this.requestId ||
          term !== this.search.trim() ||
          companyId !== Number(this.companyId)
        )
          return;
        this.results = (Array.isArray(data) ? data : []).slice(0, 30);
      } catch (error) {
        if (requestId !== this.requestId) return;
        this.results = [];
        this.error = "Não foi possível buscar os produtos. Tente novamente.";
      } finally {
        if (requestId === this.requestId) this.loading = false;
      }
    },
    async selectProduct(product) {
      const requestId = ++this.requestId;
      const companyId = Number(this.companyId);
      this.selectingId = product.id;
      this.error = "";
      try {
        const { data } = await etiquetasService.produtoExemplo({
          modelo_uuid: this.modelUuid,
          id_empresa_exemplo: companyId,
          id_produto: Number(product.id),
          opcoes: this.options,
        });
        if (
          requestId !== this.requestId ||
          companyId !== Number(this.companyId)
        )
          return;
        this.$emit("select", {
          product: data.produto || product,
          values:
            data.dados_etiqueta && typeof data.dados_etiqueta === "object"
              ? data.dados_etiqueta
              : {},
        });
        this.search = "";
        this.results = [];
      } catch (error) {
        if (requestId !== this.requestId) return;
        this.error = "Não foi possível carregar este produto para o teste.";
      } finally {
        if (requestId === this.requestId) this.selectingId = null;
      }
    },
    clearSelection() {
      this.resetSearch();
      this.$emit("clear");
    },
    resetSearch() {
      if (this.timer) clearTimeout(this.timer);
      this.timer = null;
      this.requestId += 1;
      this.search = "";
      this.results = [];
      this.error = "";
      this.loading = false;
      this.selectingId = null;
    },
    productIdentifiers(product) {
      return [
        product.codigo ? `Código ${product.codigo}` : "",
        product.referencia ? `Ref. ${product.referencia}` : "",
        product.cod_barras ? `EAN ${product.cod_barras}` : "",
      ]
        .filter(Boolean)
        .join(" · ");
    },
    formatPrice(value) {
      const price = Number(value);
      return Number.isFinite(price)
        ? price.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          })
        : "—";
    },
  },
};
